var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-icon"},[_c('icon',{attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }